/**
 * Created by Ivan on 20.06.2026
 */

const LorysDerbyStartWindow = Prefab.createWindow("lorys_derby", "lorys_derby_start_window_prefab_json");
